import { saveAs } from "file-saver";

export function downloadBase64File(base64Content, fileName, format) {
  const _downloadLink = document.createElement("a"); //Create <a>
  _downloadLink.href = `data:${format};base64,` + base64Content;
  _downloadLink.download = fileName;
  _downloadLink.click();

  return true;
}

export function downloadBlob(fileData, fileName) {
  saveAs(fileData, fileName);
}
